import { render, staticRenderFns } from "./RepCoverageWidget.vue?vue&type=template&id=bea7b516&scoped=true"
import script from "./RepCoverageWidget.vue?vue&type=script&lang=ts"
export * from "./RepCoverageWidget.vue?vue&type=script&lang=ts"
import style0 from "./RepCoverageWidget.vue?vue&type=style&index=0&id=bea7b516&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea7b516",
  null
  
)

export default component.exports